import { initializeApp } from "firebase/app";
import { updateProfile, getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC2ZFvp8UI5eujKbg2HOtam404rh287yWg",
  authDomain: "capirunners-c3308.firebaseapp.com",
  projectId: "capirunners-c3308",
  storageBucket: "capirunners-c3308.firebasestorage.app",
  messagingSenderId: "934210701278",
  appId: "1:934210701278:web:42221e63f3efaa2491ff4f",
  measurementId: "G-6K2DC65Z5E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export { app, updateProfile, getAuth, signInWithEmailAndPassword, onAuthStateChanged }